import PIXI from 'pixi.js/src';
import config from './../config/config';
import GameStore from './../stores/GameStore';
import renderHelper from './../helpers/render';

const statsView = {
  /**
   * Sets up the view
   * @returns {undefined} undefined
   */
  init() {
    this.timeText = new PIXI.Text('',
      {
        font: '24px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.timeText.resolution = 2;
    renderHelper.stage.addChild(this.timeText);

    this.statsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.statsContainer);

    this.shotsMadeText = new PIXI.Text('0',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.shotsMadeText.resolution = 2;
    this.statsContainer.addChild(this.shotsMadeText);

    this.sepText = new PIXI.Text('|',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.sepText.resolution = 2;
    this.sepText.alpha = 0.4;
    this.statsContainer.addChild(this.sepText);

    this.percentageText = new PIXI.Text('0%',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
      }
    );
    this.percentageText.resolution = 2;
    this.statsContainer.addChild(this.percentageText);

    GameStore.addChangeListener(this.onGameStoreChange.bind(this));
    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);
    this.positionGraphics();
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.statsContainer.x = (window.innerWidth / 2) - 2;
    this.statsContainer.y = (window.innerHeight / 2) - (this.statsContainer.height / 2) - 80;

    this.shotsMadeText.x = -(this.shotsMadeText.width + 20);
    this.percentageText.x = 20;

    this.timeText.x = (window.innerWidth / 2) - (this.timeText.width / 2);
    this.timeText.y = 20;
  },


  /**
   * Called when a CHANGE event is emitted from the GameStore
   * @returns {undefined} undefined
   */
  onGameStoreChange() {
    const state = GameStore.getState();
    const levelStats = state.levelStats['level' + state.currentLevelData.level];
    let madeShots = 0;
    let percentageMade = 0;

    if (levelStats) {
      madeShots = levelStats.score;

      percentageMade =
        Math.floor((levelStats.madeShots / levelStats.totalShots) * 100);

      if (isNaN(percentageMade)) {
        percentageMade = 0;
      }
    }

    this.shotsMadeText.text = madeShots;
    this.percentageText.text = percentageMade + '%';
    this.positionGraphics();
  },


  /**
   * Updates the time text
   * @param {Number} time - The time to display on the clock
   * @returns {undefined} undefined
   */
  updateTime(time) {
    if (time <= 8) {
      this.timeText.tint = config.redColor;
    }
    this.timeText.text = time;
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.statsContainer);
    renderHelper.stage.removeChild(this.timeText);
    GameStore.removeChangeListener(this.onGameStoreChange.bind(this));
  },
};

export default statsView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/stats.js
 **/